import { AllergenDto } from './allergen.dto';
import { BaseDto } from './base.dto';
import { DiscountTypeDto } from './discountType.dto';
import { OrderItemModifierDto } from './orderItemModifier.dto';
import { ProductDto } from './product.dto';
import { StockDto } from './stock.dto';
import { VATRateDto } from './vat-rate.dto';

export class OrderItemDto extends BaseDto {
  orderId: number;
  productId: number;
  menuId?: number;
  product?: ProductDto;
  quantity: number;
  price: number;
  note?: string;
  orderItemModifiers?: OrderItemModifierDto[];
  clientSideId?: string;
  clientSideOrderId?: string;
  modifierTotal?: number;
  discountAmount?: number;
  discountTypeId?: number;
  hasProductDiscount: boolean;
  orderItemDiscountType?: DiscountTypeDto;
  isBundle?: boolean;
  bundleCombinationId?: string;
  bundleIdentifier?: number;
  vatRateId?: number;
  vatRate?: VATRateDto;
  vatRateValue?: number;
  selectedForLoyalty?: boolean;
  stock?: StockDto[];
  openPrice?: number;
  allergens?: AllergenDto[];
  clickedSequence?: number;
  isUpsell?: boolean;
  isAgeVerification: boolean;
  drsValue?: number;
}
